import { useState, useContext, useRef, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Head from '@view/compoents/head/head'

export default function PcLayout () {
    const location = useLocation();

    useEffect(() => {
        // if(Utils.isMobileDevice()) return
        const html = document.querySelector('html')
        html.style.setProperty('--min-font-size', '50px');
        html.style.setProperty('--max-font-size', '999px');
        html.style.setProperty('--base-width', '1920');
    }, [])

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                overflow: "hidden",
                background: location.pathname == '/' ? `url(${require('@assets/images/login_bg.png')}) center / cover no-repeat` : "none",
            }}
        >
            <Head/>
            <Outlet />
        </div>
    )
}